import { useState } from "react"
const postInstance = 'https://asistbot.com/api/createinstance.php?access_token='
const Asistbot = () => {

    const [qr,setQr]= useState(false)
    const [access_token,setAccess_token] = useState("6bff534200d5b9707f4ceeeeb5bedda4")
    
    const init = async () => {
        const res = await createInstance()
        //console.log(res)
        if(res.status == "success"){
            getQR(res.instance_id)
        }else alert("Error en la peticion")
    }
    const createInstance = async () => {
        const res = await fetch(postInstance + access_token, { method: 'POST' })
        return res
    }
    const getQR = async (instance_id)=>{
        const res = await fetch("https://asistbot.com/api/getqrcode.php?instance_id="+instance_id+"&access_token="+access_token, { method: 'POST' })
        const image = res.base64
        setQr(image)
    }
    
    return (<div className="asistbot">
        <h1>Asistbot</h1>
        {qr && <>
            <img src={qr} ></img>
            <button onClick={init}> init </button>
        </>}
    </div>)
}
export default Asistbot


/* let asist = {
    "status": "success",
    "message": "Success",
    "base64": "data:image\/png;base64,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"
}

let instance = {
    "status": "success",
    "message": "Instance ID generated successfully",
    "instance_id": "633B727DA32C5"
} */
//const qr = "https://asistbot.com/api/getqrcode.php?instance_id=633B727DA32C5&access_token=6bff534200d5b9707f4ceeeeb5bedda4​"